import { CacheHandler } from "reusable/utils/cache";

export const notificationsCache = {
   showOnlyUnread: new CacheHandler<boolean>({ key: 'notifications:showOnlyUnread', cacheLocation: 'localStorage' })
}
